// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useSnackbar } from 'notistack';
import React from 'react';
import { Box, Card, Switch, Typography } from '@mui/material';
import { useLocalStorage } from '../../contexts/LocalStorageContext';

export const WebsocketToggle: React.FC = () => {
  const { localStorageState, setLocalStorageState } = useLocalStorage();
  const { enqueueSnackbar } = useSnackbar();

  const onToggle = () => {
    setLocalStorageState('webSocketEnabled', !localStorageState?.webSocketEnabled);
    enqueueSnackbar(`Websockets ${!localStorageState?.webSocketEnabled ? 'enabled' : 'disabled'}`);
  };
  const { webSocketEnabled } = localStorageState;
  return (
    <Card
      sx={{ mb: 1, width: '50%', p: 1, display: 'flex', alignItems: 'center' }}
      variant="outlined"
    >
      <Box>
        <Typography fontWeight="bold">WebSockets</Typography>
        <Typography variant="body2">Toggle to enable or disable WebSockets.</Typography>
      </Box>
      <Switch sx={{ ml: 'auto' }} checked={webSocketEnabled} onChange={onToggle} />
    </Card>
  );
};
